import { DocumentIcon } from "@heroicons/react/solid";
import React from "react";
import { ButtonDelete, ButtonEdit } from "../../shared/Button";
const columns = ["Matière", "Classe", "Option", "Année", "Document", "Actions"];
const data = [
	{ topic: "Mathématiques", classroom: "Terminale", option: "Mathématiques", year: "2022" },
];
const SubjectsTable = () => {
	return (
		<div className="table-container">
			<table className="table-custom">
				<thead className="thead">
					<tr>
						{columns?.map((column, index) => (
							<th scope="col" className="py-3 px-6" key={index}>
								{column}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{data.map((item, index) => (
						<tr className="bg-white border-b" key={index}>
							<td className="table-td">{item.topic}</td>
							<td className="table-td">{item.classroom}</td>
							<td className="table-td">{item.option}</td>
							<td className="table-td">{item.year}</td>
							<td className="table-td">
								<DocumentIcon width={20} />
							</td>
							<td>
								<div className="flex gap-3 px-5">
									<ButtonEdit />
									<ButtonDelete />
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default SubjectsTable;
